<template>
  <div class="meal-item">
    <div class="columns is-gapless " :class="{ selected: selected }">
      <div class="column is-4 meal-image">
        <meal-image
          class="image is-16by9"
          :src="meal.thumbUrl || meal.imageUrl"
        />
      </div>

      <div class="column meal-desc">
        <div class="columns is-mobile meal-body is-gapless">
          <div class="column">
            <text-highlighter
              class="has-text-weight-bold has-text-break-all meal-name"
              :text="meal.name"
              :highlight="highlight"
            />
            <span class="is-size-7">{{ allergens }}</span>
            <div>
              <span v-for="(mealBadge, idx) in badges" :key="idx">
                <img
                  class="small-icon"
                  :src="mealBadge.icon"
                  :title="$t(mealBadge.name)"
                />
              </span>
            </div>
          </div>
          <div class="column meal-right" style="position: relative;">
            <strong class="price">
              {{ meal.price | money }} {{ currency }}
            </strong>
          </div>
        </div>
      </div>
    </div>

    <div class="columns is-mobile is-gapless">
      <div class="column column-tags">
        <span
          v-for="mealTag in meal.categories"
          :key="mealTag"
          class="tag is-small"
        >
          <text-highlighter :text="mealTag" :highlight="highlight" />
        </span>
      </div>

      <div class="column meal-right">
        <div class="action-buttons"><slot name="right-bottom" /></div>
      </div>
    </div>
  </div>
</template>

// TODO: handle key navigation
<script>
import { TextHighlighter } from "@/components/form"
import MealImage from "@/components/meal-image"
import { allergenCodes, badgeCodes } from "@/service/meal-constants.js"

export default {
  name: "meal-item",
  props: ["meal", "selected", "currency", "highlight"],
  components: {
    TextHighlighter,
    MealImage
  },
  computed: {
    allergens() {
      return allergenCodes(this.meal.allergens, "(", ")")
    },
    badges() {
      return badgeCodes(this.meal.badges)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.meal-item {
  min-height: 8em;
  border: 1px solid $meal-item-border-color;
  border-radius: 4px;
  height: 97%;
  padding: 0.25rem;
  margin-bottom: 5px;
  .meal-name {
    white-space: pre-wrap;
  }
  &:hover {
    border: 1px solid $meal-item-border-color-hover;
  }
  &.selected {
    background-color: $primary;
  }
  .has-text-break-all {
    word-break: break-word;
  }
  .tag {
    margin-right: 0.2em;
    margin-bottom: 0.2em;
    position: relative;
    top: -0.55em;
    height: auto;
    white-space: unset;
    word-break: break-all;
  }
  .price {
    border: 1px solid $meal-item-border-color;
    border-radius: 4px;
    padding: 0.2em 0.3em;
    text-align: right;
    margin-bottom: 0.25rem;
  }
  .columns.is-gapless {
    &:not(:last-child) {
      margin-bottom: 0.75rem;
      @include mobile {
        margin-bottom: inherit;
      }
    }
    .meal-desc {
      @include mobile {
        margin-left: -0.4rem;
        margin-top: 0.3rem;
      }
    }
    .meal-right {
      margin-right: 0.25rem;
      margin-left: 0.2rem;
    }
  }
  .column {
    .meal-body {
      height: 100%;
      margin-right: -0.3em;
      margin-top: -0.3em;
      padding-top: 0.25rem;
      padding-left: 0.5rem;
    }
  }
  .small-icon {
    width: 1.5em;
    height: 1.5em;
    margin-right: 0.1em;
  }
}
.meal-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: fit-content;
}
</style>
